<template>
    <select class="form-control font-weight-bold"  id="selecDepartamento" v-model="valor"  @change="$emit('evento', valor)">
        <option value="">Seleccione Departamento...</option>
        <option v-for="d in $store.state.dataDepartamentos" :key="d.id" :value="d.id"  >{{d.departamento}}</option>
    </select>
</template>

<script>
export default {
    name:"SelectDepartamento",
    props:['valor_entrada'],
     data(){
        return{
            valor:'',
         
            }
        },
         created() {
            setTimeout(() => {
              
                  this.valor=this.valor_entrada;
            }, 100);
            
         
         //   if(this.valor_entrada!=''){
         //       this.valor=parseInt(this.valor_entrada);
         //   }else{
          //       this.valor="";
           // }
        },
         watch: {
            valor_entrada(newQuestion, oldQuestion) {
                this.valor=newQuestion;
            }
        }
    

}
</script>

